import { useState } from "react";
import { Smartphone, Share, PlusSquare, X } from "lucide-react";
import { useInstall } from "@/lib/install";

export function InstallCard({ dismissible = false, testId = "install-card" }) {
  const { installed, canPrompt, ios, install } = useInstall();
  const [hidden, setHidden] = useState(() => dismissible && localStorage.getItem("btp_install_dismissed") === "1");
  const [help, setHelp] = useState(false);
  if (installed || hidden) return null;

  const dismiss = () => {
    localStorage.setItem("btp_install_dismissed", "1");
    setHidden(true);
  };
  const onClick = async () => {
    if (canPrompt) await install();
    else setHelp(true);
  };

  return (
    <div className="relative rounded-2xl bg-slate-900 text-white p-4 space-y-3 rise" data-testid={testId}>
      {dismissible && (
        <button onClick={dismiss} aria-label="Masquer" data-testid={`${testId}-dismiss`} className="absolute top-2 right-2 w-8 h-8 grid place-items-center text-slate-400 hover:text-white">
          <X className="w-4 h-4" />
        </button>
      )}
      <div className="flex items-center gap-3 pr-6">
        <img src="/icon-192.png" alt="" className="w-12 h-12 rounded-xl" />
        <div className="flex-1">
          <div className="font-display text-xl font-bold uppercase">Installer l'appli</div>
          <div className="text-sm text-slate-300">Sur l'écran d'accueil, marche même sans réseau</div>
        </div>
      </div>
      <button
        onClick={onClick}
        data-testid={`${testId}-btn`}
        className="w-full h-12 rounded-xl bg-orange-500 hover:bg-orange-600 font-bold flex items-center justify-center gap-2 transition-colors"
      >
        <Smartphone className="w-5 h-5" /> Installer
      </button>
      {help && (
        <div className="rounded-xl bg-white/10 p-3 text-sm space-y-2" data-testid={`${testId}-help`}>
          {ios ? (
            <>
              <p className="flex items-center gap-2">1. Touchez <Share className="w-4 h-4 text-amber-400" /> <b>Partager</b> en bas de Safari</p>
              <p className="flex items-center gap-2">2. Choisissez <PlusSquare className="w-4 h-4 text-amber-400" /> <b>Sur l'écran d'accueil</b></p>
            </>
          ) : (
            <>
              <p>1. Ouvrez le menu <b>⋮</b> du navigateur</p>
              <p>2. Choisissez <b>Installer l'application</b> ou <b>Ajouter à l'écran d'accueil</b></p>
            </>
          )}
        </div>
      )}
    </div>
  );
}
